
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/neathome",
      function () {
        return require("private-next-pages/neathome.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/neathome"])
      });
    }
  